'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _customer = require('../api/customer.service');

var _customer2 = _interopRequireDefault(_customer);

var _grid = require('../components/grid.directive');

var _grid2 = _interopRequireDefault(_grid);

var _contact = require('../components/contact.directive');

var _contact2 = _interopRequireDefault(_contact);

var _contactShort = require('../components/contact-short.filter');

var _contactShort2 = _interopRequireDefault(_contactShort);

var _customer3 = require('./customer.routes');

var _customer4 = _interopRequireDefault(_customer3);

var _customer5 = require('./customer.controller');

var _customer6 = _interopRequireDefault(_customer5);

var _customer7 = require('./customer.directive');

var _customer8 = _interopRequireDefault(_customer7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.customer', [_angularUiRouter2.default, _customer2.default, _grid2.default, _contact2.default, _contactShort2.default]).config(_customer4.default).controller('CustomerController', _customer6.default).directive('tbCustomer', _customer8.default).name;


// WEBPACK FOOTER //
// ./src/app/customer/index.js